import styled from "styled-components"
import { Typography } from "../../../typography"

type InputHeight = "large" | "small"

export const InputDefault = styled(Typography).attrs<{
  $height?: InputHeight
  $fullWidth?: boolean
  $inline?: boolean
  $isInError?: boolean
}>((props) => ({
  as: props.as ?? "input",
  $variant: "body-4-regular",
  $height: props.$height ?? "large",
}))`
  color: ${({ theme }) => theme.colors.grey.$600};

  border: 1px solid ${({ theme, $isInError }) => ($isInError ? theme.colors.danger.$200 : theme.colors.grey.$200)};
  outline: 0 solid ${({ theme }) => theme.colors.grey.$400};
  box-shadow: ${({ theme }) => theme.shadows.light};
  border-radius: 0.5rem;

  &:invalid {
    border: 1px solid ${({ theme }) => theme.colors.danger.$200};
  }

  height: ${({ $height }) => ($height === "small" ? "2rem" : "2.5rem")};
  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "21.875rem")};
  padding: 0 0.5rem;
  ${({ $inline }) => ($inline ? "margin-left: 0.75rem;" : "")}

  box-sizing: border-box;

  &::placeholder {
    color: ${({ theme }) => theme.colors.grey.$400};
  }

  &:active {
    border: 1px solid ${({ theme }) => theme.colors.grey.$600};
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.grey.$400};
    border: 1px solid ${({ theme }) => theme.colors.grey.$200};
  }

  &:disabled {
    border: 1px solid ${({ theme }) => theme.colors.grey.$200};
    background-color: ${({ theme }) => theme.colors.grey.$200};
  }
`
